export default [
  {
    text: 'RG',
    value: 'RG',
  },
  {
    text: 'Comprovante de residência',
    value: 'CR',
  },
  {
    text: 'Foto da fachada',
    value: 'FF',
  },
  {
    text: 'Selfie',
    value: 'SF',
  },
  {
    text: 'Outros',
    value: 'OT',
  },
  {
    text: 'CNH',
    value: 'CNH',
  },
];
